import { ArrowBack } from "@mui/icons-material";
import { Edit, ListButton, ShowButton, SimpleForm, TextInput, useRedirect, useNotify, useRefresh } from "react-admin";
import { TopToolBar } from "../shared-components";

export const ShowNoteTitle: React.FC = ( data: any) => {
  return <a style={{color: '#ffffff', textDecoration: 'none'}} href={`#/profiles/${data.record.user_id}/show/notes`}><span style={{fontWeight: 600}}>{data.record.userName}</span> {data.record.user_id} </a>;
};

const BackToProfile = ({url}:{url: string}): JSX.Element => {
  return(
    <ListButton to={{pathname: url}}  label={'Go back'} icon={<ArrowBack/>}/>
  )};


export const EditNote: React.FC = (props: any) => {
  const notify = useNotify()
  const refresh = useRefresh()
  const redirect = useRedirect()

  const CutomShowButton = (data:any) => {
    const showPath = `/notes/${data?.id}/show`;
    return <ShowButton to={{pathname: showPath, state: {goBackUrl: props.location?.state?.goBackUrl}}} record={data.record} />
  }
  const EditActions = () => {        
    return (
      <TopToolBar left={<BackToProfile url={props.location?.state?.goBackUrl}/>} right={ <CutomShowButton {...props} />}/>
    )};

  const onSuccess = () => {
    notify('Changes saved')
    redirect('show', `/notes`, props.id, {}, { goBackUrl: props.location?.state?.goBackUrl })
    refresh()
  };
    
  return (
    <Edit title={<ShowNoteTitle/>} actions={<EditActions/>} mutationMode="pessimistic" onSuccess={onSuccess} {...props}>
      <SimpleForm warnWhenUnsavedChanges>
        <TextInput source="summary" type="text" label="Summary" variant="outlined" />
        <TextInput source="text" type="text" label="Note" variant="outlined" minRows={5} fullWidth multiline />
      </SimpleForm>
    </Edit>
  )};